/**
 * Mobile sticky Add to Cart bar.
 * Shows once the real [data-add-to-cart] button leaves the viewport. For multi-variant products it
 * renders one dropdown per option; the chosen options resolve to a variant (price + availability
 * update accordingly) and that variant is what gets added. Adding fires the theme's ajaxProduct:added
 * event so the cart drawer and upsell widget run unchanged.
 */
(function () {
  'use strict';

  var bar = document.getElementById('MobileStickyAtc');
  if (!bar) return;

  var realBtn = document.querySelector('[data-add-to-cart]');
  if (!realBtn) return;

  var stickyBtn = bar.querySelector('[data-m-sticky-add]');
  var stickyPrice = bar.querySelector('[data-m-sticky-price]');
  var optionSelects = bar.querySelectorAll('.m-sticky-atc__option');
  var pagePrice = document.querySelector('[data-product-price]');
  var multi = optionSelects.length > 0;
  var addLabel = (stickyBtn.textContent || 'Add to cart').replace(/\s+/g, ' ').trim();

  var variants = [];
  try { variants = JSON.parse(bar.querySelector('[data-m-sticky-variants]').textContent); } catch (e) { variants = []; }

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var f = (window.theme && theme.moneyFormat) || (window.Shopify && Shopify.money_format) || '${{amount}}';
      return Shopify.formatMoney(cents, f);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function currentVariant() {
    if (!multi) return variants[0] || null;
    var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < chosen.length; j++) {
        if (v.options[j] !== chosen[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function apply() {
    var v = currentVariant();
    if (stickyPrice) {
      stickyPrice.textContent = v ? money(v.price)
        : (pagePrice ? pagePrice.textContent.replace(/\s+/g, ' ').trim() : '');
    }
    var avail = v ? v.available : false;
    stickyBtn.disabled = !avail;
    stickyBtn.textContent = avail ? addLabel : 'Sold out';
  }

  // Default the dropdowns to the page's currently-selected variant (keeps the two in step).
  function syncFromPage() {
    if (multi) {
      var idEl = document.querySelector('.product-single__form [name="id"]') || document.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : NaN;
      var cur = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { cur = variants[i]; break; } }
      if (!cur) cur = variants[0];
      if (cur) {
        Array.prototype.forEach.call(optionSelects, function (s, idx) {
          if (cur.options[idx] != null) s.value = cur.options[idx];
        });
      }
    }
    apply();
  }

  syncFromPage();
  Array.prototype.forEach.call(optionSelects, function (s) { s.addEventListener('change', apply); });
  if (pagePrice && window.MutationObserver) {
    new MutationObserver(syncFromPage).observe(pagePrice, { childList: true, subtree: true, characterData: true });
  }

  // Add the resolved variant, then let the theme rebuild + open the cart drawer.
  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.disabled) return;
    var v = currentVariant();
    if (!v) return;
    stickyBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function () { openDrawer(v.id); })
      .catch(function () { stickyBtn.classList.remove('is-loading'); });
  });

  // Mirror the theme's post-add flow (rebuild drawer + open) via the event its CartDrawer listens for.
  // Fired from a hidden form with [name="id"] so the other listener (theme.js:4147) can't throw.
  function openDrawer(variantId) {
    try {
      var f = document.createElement('form');
      f.style.display = 'none';
      f.innerHTML = '<input name="id" value="' + variantId + '">';
      document.body.appendChild(f);
      f.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: {} }));
      document.body.removeChild(f);
    } catch (e) { /* no-op */ }
    stickyBtn.classList.remove('is-loading');
  }

  /* ---------- show/hide: visible when the real button is out of view AND no modal popup is open ---------- */
  var atcOut = false;

  function popupOpen() {
    var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (var i = 0; i < dialogs.length; i++) {
      var el = dialogs[i];
      if (el.id === 'CartDrawer') continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  function update() {
    bar.classList.toggle('is-visible', atcOut && !popupOpen());
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { atcOut = !e.isIntersecting; });
      update();
    }, { threshold: 0 }).observe(realBtn);
  }

  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(update, 100);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
  }
})();
